import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { logout, auth } from "../firebase";
import Logo from "../assets/logo.png";
import { Link } from "react-router-dom/cjs/react-router-dom";

function NavbarComponent() {
  const [user, loading] = useAuthState(auth);
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (user) {
      setIsLoggedOut(false);
    } else {
      setIsLoggedOut(true);
    }
  }, [user, loading]);

  function logoutSession() {
    logout();
    setIsLoggedOut(true);
  }

  return (
    <header className="sb-navbar">
      <nav className="navbar navbar-expand-lg container-fluid px-3 px-xl-5">
        {/* Logo */}
        <Link to="/" className="navbar-brand sb-navbar-brand">
          <img src={Logo} width={32} height={30} alt="StakeBits logo" />
          <span style={{ fontWeight: 700, letterSpacing: '-0.01em' }}>StakeBits</span>
        </Link>

        {/* Mobile toggler */}
        <button
          className="navbar-toggler sb-navbar-toggler ms-auto"
          type="button"
          onClick={() => setExpanded(!expanded)}
          aria-label="Toggle navigation"
          style={{
            border: '1px solid rgba(255,255,255,0.12)',
            background: 'transparent',
            color: 'rgba(255,255,255,0.6)',
            padding: '0.4rem 0.65rem',
            borderRadius: '8px',
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
          </svg>
        </button>

        {/* Nav links */}
        <div
          className={`navbar-collapse ${expanded ? 'show' : 'collapse'}`}
          id="navbarCollapse"
        >
          <ul className="navbar-nav ms-auto gap-1 py-2 py-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/tables" onClick={() => setExpanded(false)}>
                All tables
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about-us" onClick={() => setExpanded(false)}>
                About us
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/pricing" onClick={() => setExpanded(false)}>
                Pricing
              </Link>
            </li>
          </ul>

          <div className="d-flex justify-content-center pb-3 pb-lg-0 ms-5">
            {isLoggedOut ? (
              <Link
                to="/register"
                className="btn-sb-primary"
                onClick={() => setExpanded(false)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4"/>
                </svg>
                Create account
              </Link>
            ) : (
              <Link
                to="/tables"
                className="btn-sb-primary"
                onClick={() => setExpanded(false)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4"/>
                </svg>
                My account
              </Link>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
}

export default NavbarComponent;
